// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';
import ManageInventoryCategory from '@/components/inventory-category/manage';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditInventoryCategory() {
    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };
  
    useEffect(() => {
        getAccessStatus();
    }, []);
    
    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    const { data: inventoryCategory } = useQuery(
        ['inventoryCategory', id],
        () => Fetch.get({ url: `/InventoryCategory?id=${id}` }),
        { enabled: !!id }
    );

    if (!inventoryCategory) return null;

    return (
        <div>
            <ManageInventoryCategory isNew={false} manageInventoryCategory={inventoryCategory} accessStatus={accessStatus} />        
        </div>
    );
}

export default EditInventoryCategory;

export const Route = createFileRoute('/_authenticated/inventory-category/$id')({ component: EditInventoryCategory })
